// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ad_account_activity".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "meta_ad_account_activity" table (1:1 with a DB row, on the wire). */
export const metaAdAccountActivityAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    adAccountId: z.string(),
    eventTime: z.string().datetime(),
    eventType: z.string(),
    translatedEventType: z.string().nullable(),
    objectType: z.string().nullable(),
    objectId: z.string().nullable(),
    objectName: z.string().nullable(),
    actorName: z.string().nullable(),
    applicationName: z.string().nullable(),
    extraData: z.unknown().nullable(),
    raw: z.unknown().nullable(),
    fetchedAt: z.string().datetime(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=metaAdAccountActivity.js.map